import { render, staticRenderFns } from "./DatingSincerityPage.vue?vue&type=template&id=bb36592c&scoped=true"
import script from "./DatingSincerityPage.vue?vue&type=script&lang=js"
export * from "./DatingSincerityPage.vue?vue&type=script&lang=js"
import style0 from "./DatingSincerityPage.vue?vue&type=style&index=0&id=bb36592c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb36592c",
  null
  
)

export default component.exports